import React from "react";
import CustomMarkdown from "core/components/global/markdown/markdown";
import { Message } from "./types";

interface MessageListProps {
  messages: Message[];
  isLoading: boolean;
  apptheme: any;
  messagesEndRef: React.RefObject<HTMLDivElement>;
}

// Individual message component to prevent unnecessary re-renders
const MessageItem = React.memo(({ 
  message, 
  apptheme 
}: { 
  message: Message;
  apptheme: any;
}) => {
  return (
    <div
      key={message.id}
      className={`p-4 rounded-lg shadow max-w-[35vw] ${
        message.type === 'user'
          ? `ml-auto ${apptheme.name === "dark-theme" ? "bg-[#212121] text-white" : "bg-purple-100 text-black"}`
          : `mr-auto ${apptheme.name === "dark-theme" ? "bg-gray-600 text-white" : "bg-purple-100 text-black"}`
      }`}
    >
      {message.type === 'user' ? (
        <p className="text-sm">
          <CustomMarkdown content={message.content} />
        </p>
      ) : (
        <p className="text-sm">
          <CustomMarkdown content={message.content} />
        </p>
      )}
      <div className="text-xs text-gray-500 mt-1 text-right">
        {new Date(message.timestamp).toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        })}
      </div>
    </div>
  );
});

// Loading placeholder component
const LoadingPlaceholder = () => (
  <div className="p-4 bg-gray-100 rounded-lg max-w-[35vw] animate-pulse">
    <div className=" bg-gray-300 rounded w-3/4 mb-2"></div>
    <div className=" bg-gray-300 rounded w-1/2"></div>
  </div>
);

const MessageList: React.FC<MessageListProps> = ({ 
  messages, 
  isLoading, 
  apptheme,
  messagesEndRef
}) => {
  return (
    <div className="transition-column mt-3 ml-[5.5rem] me-3 col-md-10 messages d-flex flex-column h-full overflow-auto flex-grow gap-[1.5rem]">
      {messages.map((message) => (
        <MessageItem key={message.id} message={message} apptheme={apptheme} />
      ))}

      {isLoading && <LoadingPlaceholder />}
      
      <div ref={messagesEndRef} />
    </div>
  );
};

export default React.memo(MessageList);